module.exports = __webpack_public_path__ + "static/04-7c57e78ec8ca687bd81b6f40b61b91b6.jpg";